import React from "react";
import styled from "styled-components";
import fullStar from "./icons/star_solid.png";
import halfStar from "./icons/star_half.png";
import emptyStar from "./icons/star_empty.png";

const Rating = ({ rating, reviewCount }) => {
  let element = [];
  for (let i = 0; i < parseInt(rating, 10); i++) {
    element.push(<FullStar key={i} />);
  }
  let afterDot = rating.substring(rating.indexOf(".") + 1);
  if (afterDot !== "0") {
    element.push(<HalfStar key="half-star" />);

    for (let index = parseInt(rating, 10) + 1; index < 5; index++) {
      element.push(<EmptyStar key={index} />);
    }
  } else {
    for (let index = parseInt(rating, 10); index < 5; index++) {
      element.push(<EmptyStar key={index} />);
    }
  }

  return (
    <Container>
      <meta itemProp="worstRating" content="0" />
      <meta itemProp="ratingValue" content={rating} />
      <meta itemProp="bestRating" content="5" />
      {element}
      <ReviewCount itemProp="reviewCount">{reviewCount}</ReviewCount>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  flex-basis: 50%;
`;

const FullStar = styled.div`
  height: 0.6rem;
  width: 0.6rem;
  background-image: url(${fullStar});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 0.2rem;
`;

const HalfStar = styled.div`
  height: 0.65rem;
  width: 0.65rem;
  background-image: url(${halfStar});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 0.2rem;
`;
const EmptyStar = styled.div`
  height: 0.65rem;
  width: 0.65rem;
  background-image: url(${emptyStar});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 0.2rem;
`;

const ReviewCount = styled.span`
  font-size: 0.7rem;
  color: #484848;
`;
export default Rating;
